import { initAccordionGroups } from "../component/accordion.js";
import { initBlogSlider,wrapTables } from "../component/insights.js";
import { initSchemaFaqAccordion } from "../component/schema-faq.js";
import { initCommentSystem } from "../component/custom-comments-customizer.js";
import OpenContentSubList from "../component/open-content-sublist.js";
import {
  initCookieBar,
  initDmcabadge,
  initGooglePreferredSource,
} from "../component/bottom-cookie-bar.js";
import { scrollToSection } from "../component/blog-scroll-to-section.js";
import { initOfficeHoverReveal } from "../component/office-hover-reveal.js";
import { initNewsletterModal } from "../component/custom-newsletter-popup.js";
import initMobileMenu from "../component/mobile-menu.js";
import { initGlowWrapper } from "../component/glow.js";

initDmcabadge();
initCookieBar();
initGooglePreferredSource();
initAccordionGroups();
initBlogSlider();
wrapTables();
initSchemaFaqAccordion();
document.addEventListener("DOMContentLoaded", () => {
  initCommentSystem();
  new OpenContentSubList();
  initGlowWrapper();
});
scrollToSection();
initOfficeHoverReveal();
initNewsletterModal();
initMobileMenu();